/*********************************************/
/*               基本数值属性参数              */
/*********************************************/
export var ValueType;
(function (ValueType) {
    /**
     * 常数
     */
    ValueType[ValueType["CONSTANT"] = 0] = "CONSTANT";
    /**
     * 二维常数向量
     */
    ValueType[ValueType["CONSTANT_VEC2"] = 1] = "CONSTANT_VEC2";
    /**
     * 三维常数向量
     */
    ValueType[ValueType["CONSTANT_VEC3"] = 2] = "CONSTANT_VEC3";
    /**
     * 四维常数向量
     */
    ValueType[ValueType["CONSTANT_VEC4"] = 3] = "CONSTANT_VEC4";
    /**
     * 随机数
     */
    ValueType[ValueType["RANDOM"] = 4] = "RANDOM";
    /**
     * 直线
     */
    ValueType[ValueType["LINE"] = 5] = "LINE";
    /**
     * 曲线
     */
    ValueType[ValueType["CURVE"] = 6] = "CURVE";
    /**
     * 贝塞尔路径
     */
    ValueType[ValueType["BEZIER_PATH"] = 7] = "BEZIER_PATH";
    /**
     * 颜色
     */
    ValueType[ValueType["RGBA_COLOR"] = 8] = "RGBA_COLOR";
    /**
     * 渐变色
     */
    ValueType[ValueType["GRADIENT_COLOR"] = 9] = "GRADIENT_COLOR";
    /**
     * 蒙版形状点集
     */
    ValueType[ValueType["SHAPE_POINTS"] = 10] = "SHAPE_POINTS";
    /**
     * 蒙版形状切分
     */
    ValueType[ValueType["SHAPE_SPLITS"] = 11] = "SHAPE_SPLITS";
    /**
     * 直线路径
     */
    ValueType[ValueType["LINEAR_PATH"] = 12] = "LINEAR_PATH";
    /**
     * 多色
     */
    ValueType[ValueType["COLORS"] = 13] = "COLORS";
    /**
     * 二进制指针
     */
    ValueType[ValueType["BINARY"] = 20] = "BINARY";
    /**
     * 贝塞尔曲线
     */
    ValueType[ValueType["BEZIER_CURVE"] = 21] = "BEZIER_CURVE";
    /**
     * 贝塞尔曲线路径
     */
    ValueType[ValueType["BEZIER_CURVE_PATH"] = 22] = "BEZIER_CURVE_PATH";
    /**
     * 贝塞尔曲线四元数
     */
    ValueType[ValueType["BEZIER_CURVE_QUAT"] = 23] = "BEZIER_CURVE_QUAT";
    /**
     * 颜色曲线
     */
    ValueType[ValueType["COLOR_CURVE"] = 24] = "COLOR_CURVE";
    /**
     * Vector4 曲线
     */
    ValueType[ValueType["VECTOR4_CURVE"] = 25] = "VECTOR4_CURVE";
    /**
     * Vector2 曲线
     */
    ValueType[ValueType["VECTOR2_CURVE"] = 26] = "VECTOR2_CURVE";
    /**
     * Vector3 曲线
     */
    ValueType[ValueType["VECTOR3_CURVE"] = 27] = "VECTOR3_CURVE";
})(ValueType || (ValueType = {}));
/**
 * 关键帧类型
 */
export var BezierKeyframeType;
(function (BezierKeyframeType) {
    BezierKeyframeType[BezierKeyframeType["AUTO"] = 0] = "AUTO";
    BezierKeyframeType[BezierKeyframeType["EASE"] = 1] = "EASE";
    BezierKeyframeType[BezierKeyframeType["EASE_IN"] = 2] = "EASE_IN";
    BezierKeyframeType[BezierKeyframeType["EASE_OUT"] = 3] = "EASE_OUT";
    BezierKeyframeType[BezierKeyframeType["LINE"] = 4] = "LINE";
    BezierKeyframeType[BezierKeyframeType["HOLD"] = 5] = "HOLD";
    BezierKeyframeType[BezierKeyframeType["LINE_OUT"] = 6] = "LINE_OUT";
})(BezierKeyframeType || (BezierKeyframeType = {}));
